import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { allKeys, basicKeys } from "../../lib/audioTools";
import metaActions from "../../state/meta/actions";
import store from "../../store";

class KeySelector extends PureComponent {
	static propTypes = {
		selectedKeyNumber: PropTypes.number
	};

	setSelectedKey(selectedKey) {
		store.dispatch(metaActions.update({ selectedKey, highlight: null }));
	}

	handleSelection = (evt) => {
		this.setSelectedKey(parseInt(evt.target.value, 10));
	}

	renderOption(key, prefix) {
		let n = key.number();

		return (
			<option
				value={n}
				key={`${prefix}-${n}`}>
				{ key.richName() }
			</option>
		);
	}

	render() {
		let { selectedKeyNumber } = this.props;
		let bk = basicKeys();
		let ak = allKeys();

		return (
			<select
				value={selectedKeyNumber}
				onChange={this.handleSelection}>
				<option value={-1}>None</option>
				<optgroup label="Basic keys">
					{ bk.map((key) => this.renderOption(key, "b")) }
				</optgroup>
				<optgroup label="All keys">
					{ ak.map((key) => this.renderOption(key, "a")) }
				</optgroup>
			</select>
		);
	}
}

export default KeySelector;
